"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _product = require("@/api/product");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _ProductModal = _interopRequireDefault(require("./components/ProductModal.vue"));
var _ProductItem = _interopRequireDefault(require("./components/ProductItem.vue"));
var _categoryProduct = require("@/api/category-product");
var _ProductRatesModal = _interopRequireDefault(require("./components/ProductRatesModal.vue"));
var _vueBarcode = _interopRequireDefault(require("vue-barcode"));
var ProductPage = /*#__PURE__*/function (_Vue) {
  function ProductPage() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "query", {
      isPublished: null,
      productCategoryId: null,
      page: 1,
      limit: 12,
      search: null,
      categoryId: null
    });
    (0, _defineProperty2.default)(_this, "categories", []);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(ProductPage, _Vue);
  return (0, _createClass2.default)(ProductPage, [{
    key: "handleReview",
    value: function handleReview(product) {
      this.$refs.productRatesModal.handleOpen(product.id);
    }
  }, {
    key: "fetchCategories",
    value: function fetchCategories() {
      var _this2 = this;
      _categoryProduct.categoryProductApi.findAll().then(function (res) {
        return _this2.categories = res.data.data;
      });
    }
  }, {
    key: "onChangePriority",
    value: function onChangePriority(data) {
      var _this3 = this;
      this.$set(data, "loading", true);
      _product.productApi.update(data.id, {
        product: {
          priority: data.priority
        }
      }).finally(function () {
        return _this3.$set(data, "loading", false);
      });
    }
  }, {
    key: "onStarProduct",
    value: function onStarProduct(data) {
      // this.$set(data, "loadingStar", true);
      // productApi
      //   .update(data.id, {
      //     product: {
      //       isFeatured: !data.isFeatured,
      //     },
      //   })
      //   .then(() => (data.isFeatured = !data.isFeatured))
      //   .finally(() => this.$set(data, "loadingStar", false));
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(product) {
      var _this4 = this;
      this.$confirm("Bạn chắc chắn muốn xóa dữ liệu này?", "Cảnh báo", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Không",
        type: "warning"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.$set(product, "loading", true);
              _product.productApi.remove(product.id).then(function () {
                return _this4.fetchData();
              }).finally(function () {
                return _this4.$set(product, "loading", false);
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.productModal.handleUpdate(row);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.productModal.handleCreate();
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
      this.fetchCategories();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this5 = this;
      this.listLoading = true;
      _product.productApi.findAll(this.query).then(function (res) {
        _this5.data = res.data.products;
        _this5.total = res.data.total;
      }).finally(function () {
        return _this5.listLoading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
ProductPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductModal: _ProductModal.default,
    Pagination: _index.default,
    ProductItem: _ProductItem.default,
    ProductRatesModal: _ProductRatesModal.default,
    barcode: _vueBarcode.default
  }
})], ProductPage);
var _default = exports.default = ProductPage;